import "$styles/index.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

// Navbar shadow on scroll
window.addEventListener("scroll", () => {
  const navbar = document.getElementById("navbar")
  if (navbar && window.scrollY > 0) {
    navbar.classList.add("scrolled")
  } else if (navbar) {
    navbar.classList.remove("scrolled")
  }
})

// Marquee pause/play control (WCAG 2.2 SC 2.2.2)
const marqueeToggle = document.getElementById("marquee-toggle")
if (marqueeToggle) {
  marqueeToggle.addEventListener("click", () => {
    const track = document.querySelector(".scroll-track")
    if (!track) return
    const paused = track.classList.toggle("paused")
    marqueeToggle.setAttribute("aria-pressed", String(paused))
    marqueeToggle.textContent = paused ? "Play motion" : "Pause motion"
  })
}
